// components/modals/web-modals/SignUpModal.jsx

import { useTranslation } from 'react-i18next';
import BaseModalWeb from './BaseModalWeb';
import RegisterComponent from '../../../auth/components/RegisterComponent';

const SignUpModal = ({ isOpen, onRequestClose, openLoginModal }) => {
  const { t } = useTranslation();

  return (
    <BaseModalWeb
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Sign Up Modal"
      className="ReactModal__Content modal--web modal--500px"
      overlayClassName="ReactModal__Overlay modal-overlay--web"
    >
      <h2 style={{ textAlign: 'center', marginTop: 0, color: 'var(--green-darkest)' }}>
        {t('sign_up')}
      </h2>

      <RegisterComponent
        onSuccess={() => {
          alert(t('confirmation_message'));
          onRequestClose();
        }}
      />

      <div style={{ textAlign: 'center', marginTop: '1rem' }}>
        <button
          className="web-modal-button--link"
          onClick={() => {
            onRequestClose();
            openLoginModal();
          }}
        >
          {t('already_have_an_account_login')}
        </button>
      </div>
    </BaseModalWeb>
  );
};

export default SignUpModal;